import { render, staticRenderFns } from "./recentlyDocument.vue?vue&type=template&id=7904f49f&scoped=true&"
import script from "./recentlyDocument.vue?vue&type=script&lang=js&"
export * from "./recentlyDocument.vue?vue&type=script&lang=js&"
import style0 from "./recentlyDocument.vue?vue&type=style&index=0&id=7904f49f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7904f49f",
  null
  
)

export default component.exports